import { useRef, useState } from 'react';

type UseAsyncClickOptions = {
  debounceMs?: number;
};

export function useAsyncClick<T extends any[]>(
  fn: (...args: T) => Promise<unknown> | unknown,
  { debounceMs = 0 }: UseAsyncClickOptions = {}
) {
  const [isRunning, setIsRunning] = useState(false);
  const lastRunAtRef = useRef(0);

  const run = async (...args: T) => {
    const now = Date.now();
    if (isRunning) return;
    if (debounceMs && now - lastRunAtRef.current < debounceMs) return;
    lastRunAtRef.current = now;

    setIsRunning(true);
    try {
      await Promise.resolve(fn(...args));
    } finally {
      setIsRunning(false);
    }
  };

  return { run, isRunning };
}
